import {
  ArrowLeftSvg,
  color,
  Link,
  PrimaryText,
  spacing,
  StyleProps,
  useColorMode,
} from 'deepstash-ui';
import useRouter from 'hooks/useRouter';
import React from 'react';
import { Analytics, Events } from 'src/services/analytics';
import { PageType } from 'types/types';
import actionStrings from 'utils/strings/actionStrings';
import LabelButton from '../buttons/LabelButton';

interface BackButtonProps {
  location: PageType;
  customData?: {
    pageTitle: string;
    pageLink: string;
  };
}

const BackButton: React.FC<BackButtonProps & StyleProps> = ({
  location,
  customData,
  ...props
}) => {
  const router = useRouter();
  const { colorMode } = useColorMode();
  const goBack = (e: any) => {
    e.preventDefault();
    Analytics.logEvent({
      eventName: Events.consumption.goBack,
      properties: {
        location: location,
      },
      platforms: ['amplitude'],
    });

    if (customData?.pageLink) {
      router.push(customData.pageLink);
    } else if ((window?.history?.length ?? 0) <= 2) {
      router.push('/');
    } else {
      router.back();
    }
  };

  const text = (
    <PrimaryText type="bold">
      {actionStrings.back}
      {customData ? ' to ' + customData.pageTitle : ''}
    </PrimaryText>
  );

  return (
    <LabelButton
      py={spacing.toRem(4)}
      onClick={e => goBack(e)}
      ml={spacing.toRem(-10)}
      display="flex"
      color={color[colorMode].primary}
      _hover={{ color: color[colorMode].primary }}
      {...props}
    >
      <ArrowLeftSvg
        boxSize={spacing.L.rem}
        cursor="pointer"
        mr={spacing.XXS.rem}
      />
      {customData?.pageLink ? (
        <Link href={'https://deepstash.com' + customData.pageLink}>{text}</Link>
      ) : (
        text
      )}
    </LabelButton>
  );
};

export default BackButton;
